import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CompanionStatus, InstructionsState } from "./companion.types";
import { dictateTasks } from "./companion.thunk";

const initialState: InstructionsState = {
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
  status: "idle",
};

export const companionSlice = createSlice({
  name: "instructions",
  initialState,
  reducers: {
    setCompanionStatus: (state, action: PayloadAction<CompanionStatus>) => {
      state.status = action.payload;
    },
    setIsSuccess: (state, action: PayloadAction<boolean>) => {
      state.isSuccess = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // External
      .addCase(dictateTasks.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(dictateTasks.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload as string;
      })
      .addCase(dictateTasks.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      });
  },
});

export const { setIsSuccess, setCompanionStatus } = companionSlice.actions;
export default companionSlice.reducer;
